import { Site } from '@envato/foundation-types'

import * as Loadable from 'react-loadable'

import { IPageComponent } from '../../../typings/pageComponent'
import LoadingCover from '../../components/loadingCover'

import {
  fetchCategoryPageData,
  onBeforeCategoryPageView
} from '../../../common/actions/categoryPage'

const CategoryPageLoadableContainer = (Loadable as any)({
  loader: () =>
    import(/* webpackChunkName: "categoryPage" */ './categoryPageContainer'),
  loading: LoadingCover,
  webpack: () => [require.resolveWeak('./categoryPageContainer')],
  modules: ['./categoryPageContainer']
}) as IPageComponent<any>

CategoryPageLoadableContainer.onBeforePageView = ({ store }) => {
  return store.dispatch(onBeforeCategoryPageView())
}

CategoryPageLoadableContainer.loadData = ({
  store,
  location,
  apiAppUrlPrefix
}) => {
  const state = store.getState()

  if (state.common.currentSite === Site.themeforest) {
    return store.dispatch(fetchCategoryPageData(location, apiAppUrlPrefix))
  } else {
    return Promise.resolve()
  }
}

export default CategoryPageLoadableContainer
